import { render } from "./Contacts.vue?vue&type=template&id=23be3ea5&scoped=true"
import script from "./Contacts.vue?vue&type=script&lang=js"
export * from "./Contacts.vue?vue&type=script&lang=js"

import "./Contacts.vue?vue&type=style&index=0&id=23be3ea5&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23be3ea5"]])

export default __exports__